import { Element, Group } from '@ritabygglov/core';
import { useCallback } from 'react';
import { UpdateCommand } from '../commands/UpdateCommand';
import { FontSizeConfig } from '../components/Controls/controlsConfig';
import { useAppState } from '../context/AppState/useAppState';
import { expandGroupChildren } from '../helpers/groupHelpers';
import { copy } from '../helpers/utility';
import { createUpdateChangeAction } from '../services/ChangeTypes';

export const useElementUpdate = () => {
  const { appState, commandManager, session } = useAppState();
  const userId = session.currentUserId;

  const updateElement = useCallback(
    (element: Element, updates: Partial<Element> | Element) => {
      const el = copy(element);
      const newElement = { ...el, ...updates } as Element;
      createUpdateChangeAction(newElement, el, false, commandManager, userId);
    },
    [commandManager, userId]
  );

  const updateElementStyle = useCallback(
    (
      element: Element,
      styleUpdates: Record<string, unknown> | FontSizeConfig
    ) => {
      const el = copy(element);
      const newElement = {
        ...el,
        style: {
          ...el.style,
          ...styleUpdates,
        },
      } as Element;
      createUpdateChangeAction(newElement, el, false, commandManager, userId);
    },
    [commandManager, userId]
  );

  const updateGroup = useCallback(
    (
      group: Group,
      transform: (
        group: Group,
        children: Element[]
      ) => { group: Group; children: Element[] }
    ) => {
      const children = expandGroupChildren(group, appState.elements);
      const updated = transform(group, children);
      commandManager.executeCommand(
        new UpdateCommand(
          [updated.group, ...updated.children],
          [group, ...children],
          userId,
          false
        )
      );
    },
    [appState, commandManager, userId]
  );

  return { updateElement, updateElementStyle, updateGroup };
};
